module.exports = __webpack_public_path__ + "static/media/359.d109e356.svg";